export default {
  tos: `
  By creating an account you accept the
  <a href="/privacy-policy" target="_blank">Privacy policy</a>
  and the <a href="/terms-of-service" target="_blank">Terms of service</a>
  `
}
